import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../AuthContext';
import api from '../api';

const SmartRedirect: React.FC = () => {
  const { user } = useAuth();
  const isComplete = !!(user?.photo_url && user?.voice_recording_url && user?.location);

  const isLaunched = user?.launched;

  const { data: statusData, isLoading } = useQuery({
    queryKey: ['conversations', 'status'],
    queryFn: () => api.get('/api/conversations/status').then(r => r.data),
    enabled: isComplete && !!isLaunched,
  });

  if (!isComplete) {
    return <Navigate to="/profile" replace />;
  }

  if (!isLaunched) {
    return <Navigate to="/discover" replace />;
  }

  if (isLoading || !statusData) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress sx={{ color: "primary.main" }} />
      </Box>
    );
  }

  const target = (statusData.active_count > 0 || statusData.has_pending_feedback)
    ? '/conversations'
    : '/discover';

  return <Navigate to={target} replace />;
};

export default SmartRedirect;
